// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"5a16e013","732":"2fa2427d","977":"f1aae1b0"}[chunkId] + ".chunk.js");